(() => {
  'use strict';
  if(customElements.get('sale-hero-slideshow'))return;
  customElements.define('sale-hero-slideshow',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;this.initialized=true;
      this.frames=[...this.querySelectorAll('.sale-hero__piece')];
      this.button=this.querySelector('[data-hero-pause]');
      if(this.frames.length!==2||!this.button)return;
      const unique=new Map();
      for(const card of this.closest('sale-studio')?.querySelectorAll('[data-grid] .sale-card')||[]){
        try{
          const name=(card.querySelector('h3')?.textContent||'').toLowerCase();
          if(/\b(shoes?|slippers?|sneakers?|boots?|mules?|sandals?|footwear)\b/.test(name))continue;
          const variants=JSON.parse(card.querySelector('[data-variants]').textContent);
          if(!variants.some(v=>v.available&&v.compare>v.price))continue;
          const image=card.querySelector('.sale-card__image>img');
          const url=card.dataset.baseUrl;
          if(!image||!url)continue;
          unique.set(url,{url,title:card.querySelector('.sale-card__image').getAttribute('aria-label')||image.alt,src:image.getAttribute('src'),srcset:image.getAttribute('srcset')||''});
        }catch{/* A malformed card must not affect the rest of the page. */}
      }
      this.items=[...unique.values()];this.cursor=0;this.failed=new Set();
      if(this.items.length<3)return;
      this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.manualPaused=this.dataset.autoplay==='false'||this.motion.matches;
      this.inView=true;this.hovered=false;this.focused=false;
      this.controller=new AbortController();const options={signal:this.controller.signal};
      this.button.hidden=false;
      this.button.addEventListener('click',()=>{this.manualPaused=!this.manualPaused;this.updateButton();},options);
      this.addEventListener('pointerenter',e=>{if(e.pointerType!=='touch')this.hovered=true;},options);
      this.addEventListener('pointerleave',()=>{this.hovered=false;},options);
      this.addEventListener('focusin',e=>{this.focused=Boolean(e.target.closest('.sale-hero__piece'));},options);
      this.addEventListener('focusout',()=>queueMicrotask(()=>{this.focused=Boolean(document.activeElement?.closest('sale-hero-slideshow .sale-hero__piece'));}),options);
      this.motion.addEventListener('change',e=>{if(e.matches){this.manualPaused=true;this.updateButton();}},options);
      if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;},{threshold:.05});this.observer.observe(this);}
      this.updateButton();this.prepare();
      this.interval=setInterval(()=>this.advance(),Math.max(1000,Number(this.dataset.interval)||1000));
    }
    disconnectedCallback(){clearInterval(this.interval);clearTimeout(this.transitionTimer);this.controller?.abort();this.observer?.disconnect();this.initialized=false;this.prepared=null;}
    updateButton(){this.button.textContent=this.manualPaused?'Play slideshow':'Pause slideshow';this.button.setAttribute('aria-label',this.manualPaused?'Play product slideshow':'Pause product slideshow');this.button.setAttribute('aria-pressed',String(this.manualPaused));}
    choosePair(){
      const current=new Set(this.frames.map(a=>a.getAttribute('href'))),pair=[];
      for(let step=0;step<this.items.length*2&&pair.length<2;step++){
        const item=this.items[this.cursor++%this.items.length];
        if(this.failed.has(item.url)||pair.some(p=>p.url===item.url))continue;
        if(current.has(item.url)&&this.items.length-this.failed.size>=4)continue;
        pair.push(item);
      }
      return pair;
    }
    preload(item,index){
      return new Promise((resolve,reject)=>{
        const image=new Image();image.alt=item.title;image.className='sale-hero__slide-enter';image.decoding='async';
        const timeout=setTimeout(()=>{image.onload=null;image.onerror=null;reject(item);},12000);
        image.onload=async()=>{clearTimeout(timeout);try{await image.decode();}catch{}resolve(image);};
        image.onerror=()=>{clearTimeout(timeout);reject(item);};
        image.sizes=this.frames[index].querySelector('img')?.getAttribute('sizes')||'(max-width:749px) 48vw,28vw';
        if(item.srcset)image.srcset=item.srcset;image.src=item.src;
      });
    }
    async prepare(){
      if(this.preparing||this.prepared||!this.isConnected)return;
      const pair=this.choosePair();if(pair.length<2)return;
      this.preparing=true;
      try{const images=await Promise.all(pair.map((item,index)=>this.preload(item,index)));if(this.isConnected)this.prepared={pair,images};}
      catch(item){if(item?.url)this.failed.add(item.url);}
      finally{this.preparing=false;}
    }
    advance(){
      if(!this.isConnected||this.manualPaused||this.hovered||this.focused||document.hidden||!this.inView)return;
      if(!this.prepared){this.prepare();return;}
      const {pair,images}=this.prepared;this.prepared=null;
      const oldImages=this.frames.map(a=>[...a.querySelectorAll('img')]);
      this.frames.forEach((anchor,index)=>{anchor.setAttribute('href',pair[index].url);anchor.setAttribute('aria-label',pair[index].title);anchor.append(images[index]);oldImages[index].forEach(img=>img.setAttribute('aria-hidden','true'));});
      requestAnimationFrame(()=>requestAnimationFrame(()=>{
        if(!this.isConnected)return;
        images.forEach(img=>img.classList.remove('sale-hero__slide-enter'));
        oldImages.flat().forEach(img=>{img.style.opacity='0';});
        clearTimeout(this.transitionTimer);this.transitionTimer=setTimeout(()=>oldImages.flat().forEach(img=>img.remove()),250);
      }));
      this.prepare();
    }
  });
})();
